import { FlexBoxView, getFlexNode } from '@play-co/timestep-core/flexbox';
import { View } from '@play-co/timestep-core/ui';
import ButtonScaleViewWithText, {
  ButtonScaleViewWithTextOpts,
} from 'src/lib/ui/components/ButtonScaleViewWithText';
import uiConfig from 'src/lib/ui/config';
import i18n from 'src/lib/i18n/i18n';
import { track } from 'src/lib/analytics/utils';
import sounds from 'src/lib/sounds';
import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import { getSupportMail } from 'src/lib/utils';
import { user } from 'src/StateObserver';
import { loginToLINE } from 'src/lib/native/native.login';
import BadgeNotification from 'src/game/badge/BadgeNotification';

const baseButtonOpts: Partial<ButtonScaleViewWithTextOpts> = {
  ...uiConfig.buttons.primary,
  width: 410,
  height: 77,
  fontSize: 30,
  labelOffsetY: -3,
  font: 'Body',
};

type FooterCTA = 'login' | 'support' | 'faq';

type FooterCTAOpts = {
  superview: View;
  items: FooterCTA[];
};

export class FooterCTAs extends FlexBoxView {
  constructor(opts: FooterCTAOpts) {
    super({
      superview: opts.superview,
      flex: {
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
        paddingVertical: 10,
      },
    });

    opts.items.forEach((item) => {
      switch (item) {
        case 'login':
          this.createLoginButton();
          break;
        case 'support':
          this.createSupportButton();
          break;
        case 'faq':
          this.createFaqButton();
          break;
      }
    });
  }

  private createLoginButton() {
    const button = new ButtonScaleViewWithText({
      superview: this,
      ...baseButtonOpts,
      ...uiConfig.buttons.LINEButton,
      localeText: () => i18n('openWebDemo.popupLineDemoLogin.login'),
      onClick: async () => {
        sounds.sfx.play('ok');
        await loginToLINE();
      },
      tracking: {
        feature: 'guest',
        $subFeature: 'guest_settings_LINE_login',
      },
    });

    new BadgeNotification({
      superview: button,
      x: 394,
      y: -12,
      visible: true,
    });

    getFlexNode(button).marginVertical = 5;
  }

  private createSupportButton() {
    const button = new ButtonScaleViewWithText({
      superview: this,
      ...baseButtonOpts,
      localeText: () => i18n('error.support.contactSupport'),
      onClick: async () => {
        sounds.sfx.play('ok');
        const supportEmail = getSupportMail();
        const subject = `${i18n('error.support.supportSubject')} GID:${
          user().id
        }`;
        window.location.assign(`mailto:${supportEmail}?subject=${subject}`);
      },
      tracking: {
        feature: 'settings',
        $subFeature: 'popup-settings-contact-support',
      },
    });
    getFlexNode(button).marginVertical = 5;
  }

  private createFaqButton() {
    const button = new ButtonScaleViewWithText({
      superview: this,
      ...baseButtonOpts,
      localeText: () => i18n('settings.faq'),
      onClick: async () => {
        sounds.sfx.play('ok');
        track('CSWidgetOpen', {});
        await openPopupPromise('popupFaq', {});
      },
      tracking: { feature: 'settings', $subFeature: 'popup-settings-faq' },
    });
    getFlexNode(button).marginVertical = 5;
  }
}
